import { defineMessages } from "react-intl";

export const messages = defineMessages({
  usedGiftCard: {
    id: "yivxZJ",
    defaultMessage: "Paid with Gift Card: ({link})",
    description: "order payment",
  },
});
